import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=fd70c8ce"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=fd70c8ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports